import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { VehicleRoadTaxRecordCategoryEnum } from '../enums/vehicle-road-tax-record-category.enum';

/**
 * Create vehicle road tax DTO
 */
export class CreateVehicleRoadTaxDto {
  color?: string | null;
  externalReference?: string | null;
  notes?: string | null;
  recordCategory!: VehicleRoadTaxRecordCategoryEnum;
  @TransformDate()
  startsAt!: Date;
  @TransformDate()
  endsAt!: Date;
  @TransformInt()
  vehicleId!: number;
  taxRateType?: TaxRateTypeEnum | null;
  @TransformFloat()
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  @TransformFloat()
  amount?: number | null;
  @TransformFloat()
  totalNet?: number | null;
  @TransformFloat()
  totalTax?: number | null;
  @TransformFloat()
  totalGross?: number | null;
  tags?: TagDto[] | null;
  files?: FileDto[] | null;
}
